import { render, staticRenderFns } from "./AppAttributeTypeSelector.vue?vue&type=template&id=2d69946a&scoped=true"
import script from "./AppAttributeTypeSelector.vue?vue&type=script&lang=ts"
export * from "./AppAttributeTypeSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d69946a",
  null
  
)

export default component.exports